
        var result = require("!!../../../../../../node_modules/css-loader/dist/cjs.js??ref--10-1!../../../../../../node_modules/sass-loader/dist/cjs.js??ref--10-2!./monitored-train-summary.component.sass");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    